import Toast from "react-native-toast-message";

import React, { useEffect, useRef, useState } from "react";
import { DeviceEventEmitter } from "react-native";

import { resetVideo } from "../http/events";
import AppSwitchRow from "./AppSwitchRow";
import EventPersonalizeUploadCard from "./EventPersonalizeUploadCard";
import { vodEventMutation } from "./EventPersonalizeUploadUtils";
import FormSubtitle from "./FormSubtitle";
import { useActionSheet } from "@/components/hooks/useActionSheet";
import { t } from "@/localization";

const EventVideoUpload = ({
  event,
  subtitleText,
  uploadButtonText,
  hideSubtitle = false,
  hideNotifyGuests = false,
  forceShowUploadForm = false,
  uploadMode,
  insertIndex,
  uploadIntent,
  onUploadStart,
  onUploadQueued,
  onUploadError,
}) => {
  const { showActionSheetWithOptions } = useActionSheet();
  const [notifyGuests, setnotifyGuests] = useState(false);
  const notifyRef = useRef(false);
  useEffect(() => {
    notifyRef.current = notifyGuests;
  }, [notifyGuests]);

  useEffect(() => {
    //called from
    const sub = DeviceEventEmitter.addListener(
      "upload-message",
      ({ message, type }) => {
        Toast.show({
          text1: message,
          type,
        });
      }
    );
    return () => {
      sub.remove();
    };
  }, []);

  const { slug, event_status } = event;

  const onDeletePress = async ({ title, onConfirm }) => {
    showActionSheetWithOptions(
      {
        options: [t("Delete"), t("Cancel")],
        cancelButtonIndex: 1,
        destructiveButtonIndex: 0,
        title: title,
      },
      (buttonIndex) => {
        if (buttonIndex === 0) {
          onConfirm();
        }
      }
    );
  };

  const uploadVideoOnComplete = async ({ vod, error }) => {
    if (error || !vod) {
      const uploadError = error || t("Could not finish upload");
      DeviceEventEmitter.emit("upload-message", {
        message: uploadError,
        type: "error",
      });
      if (typeof onUploadError === "function") onUploadError(uploadError);
      return;
    }

    console.log(
      "OnComplete",
      notifyRef.current,
      slug,
      vod,
      uploadMode,
      insertIndex
    );
    const result = await vodEventMutation(
      slug,
      vod,
      notifyRef.current,
      uploadMode,
      insertIndex
    );

    if (result?.errors) {
      if (typeof onUploadError === "function") {
        onUploadError(t("Could not queue video conversion"));
      }
      return;
    }

    if (typeof onUploadQueued === "function") {
      onUploadQueued({ vod, uploadMode, insertIndex });
    }

    DeviceEventEmitter.emit("upload-message", {
      message: t("Event video is uploaded and will be processed now"),
    });
  };

  return (
    <>
      {!hideSubtitle && (
        <FormSubtitle>
          {subtitleText ||
            (event_status === "past"
              ? t(
                  "Upload an edited or backup recording of the live stream. This will replace the current video on event page."
                )
              : t(
                  "Upload video to event page. Video will show on event page before Live Stream starts. Once you go Live, the live stream will replace the uploaded video automatically"
                ))}
        </FormSubtitle>
      )}

      <EventPersonalizeUploadCard
        event={event}
        isVideo={true}
        uploadButtonText={uploadButtonText}
        forceShowUploadForm={forceShowUploadForm}
        onComplete={uploadVideoOnComplete}
        onUploadStart={onUploadStart}
        onUploadError={onUploadError}
        notifyGuests={!!notifyGuests}
        // Upload Service v2 (web): the card uploads and evt.live queues the
        // conversion, so onComplete/vodEventMutation aren't used there.
        uploadMode={uploadMode}
        insertIndex={insertIndex}
        uploadMeta={uploadIntent ? { intent: uploadIntent } : undefined}
        onDeletePress={() => {
          onDeletePress({
            title: t("Delete Uploaded Video?"),
            onConfirm: () => resetVideo(event.slug),
          });
        }}
      />

      {!hideNotifyGuests && (
        <AppSwitchRow
          isOn={notifyGuests}
          onToggle={setnotifyGuests}
          label={t("Notify all guests when it's uploaded")}
        />
      )}
    </>
  );
};

export default EventVideoUpload;
